import styled from 'styled-components';
import { colors } from '../../colors';

interface IContainerProps {
  bgColor: keyof typeof colors | null;
  borderColor: keyof typeof colors | null;
}

export const Container = styled.div<IContainerProps>`
  background: ${(props) => (props.bgColor ? colors[props.bgColor] : '#F2F6FE')};
  padding: 8px 14px;
  text-align: center;
  border: 1px solid
    ${(props) => (props.borderColor ? colors[props.borderColor] : '#4683f3')};
  border-radius: 8px;
  width: 100%;
`;

export const Text = styled.h5`
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  font-family: 'DM Sans';
  margin-bottom:0px ;
`;
